import PaymentPageTitle from './PaymentPageTitle';
export default PaymentPageTitle;
